import { render } from "./ProductRouter.vue?vue&type=template&id=5e746e4d&lang=true"
import script from "./ProductRouter.vue?vue&type=script&lang=js"
export * from "./ProductRouter.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__